module.exports = __webpack_public_path__ + "img/share_top.4420a9cf.png";